import React from 'react';
import './Mixes.css';
import mixesArt from '../media/mixes_art.jpg';

const Mixes: React.FC = () => {
  const mixes = [
    {
      date: "Tue 9th Mar 2021",
      title: "B.I.G. Tribute",
      url: "https://www.icloud.com/iclouddrive/0EEAwC5-V50Vdg_8wqyYkYUOw#2021-03-09_18-53-31-BIG-Tribute"
    },
    {
      date: "Sat 27th Mar 2021",
      title: "R&B/Hip Hop VOL1",
      url: "https://www.icloud.com/iclouddrive/0sjuWrI8dPgOsiXewVcksE0mQ#2021-03-27_18-00-00-R%26B1"
    },
    {
      date: "Sat 4th April 2021",
      title: "R&B/Hip Hop VOL2",
      url: "https://www.icloud.com/iclouddrive/0uoWxpvjoknsMa2GfoMzm7e1Q#2021-04-24_18-00-00-R%26B2"
    },
    {
      date: "Sat 23rd May 2021",
      title: "Freestyle #2",
      url: "https://www.icloud.com/iclouddrive/0yhAyf5N6GLc5_6LPaCvb3Xfw#2021-05-22_18-00-00-FREESTYLE2"
    },
    {
      date: "Sat 6th June 2021",
      title: "Freestyle #3",
      url: "https://www.icloud.com/iclouddrive/0-ThGh-br6WUXagVpwgtc9nyg#2021-06-06_18-00-00-FREESTYLE3"
    }
  ];

  return (
    <div className="mixes page-container">
      <div className="page-image-column">
        <img src={mixesArt} alt="Mixes" />
      </div>
      <div className="page-content-column">
        <h2>"MIC-FREE"</h2>
        <p className="mixes-description">Provided for promotional use only</p>
        
        <div className="mixes-table">
          <table>
            <thead>
              <tr>
                <th>RECORDED</th>
                <th>DOWNLOAD</th>
              </tr>
            </thead>
            <tbody>
              {mixes.map((mix, index) => (
                <tr key={index}>
                  <td>{mix.date}</td>
                  <td>
                    <a href={mix.url} target="_blank" rel="noopener noreferrer">
                      {mix.title} ⬇
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Mixes;
